export const SH_LOGIN_ERROR_CODE = 'payment_source_login_required';
export const STRONGHOLD = 'STRONGHOLD';
export const AEROPAY = 'AEROPAY';



// WEBPACK FOOTER //
// ./src/const/ach_const.js